import Axios from 'axios';
import config from './config.service';
import {env} from '@/services/env.service';
import { Theme } from '@loopia-group/services';
import store from '../store';
import { StoreActions } from '../store/const.enum';
import { setConfigValues } from '@loopia-group/services';

const themes = import.meta.glob('../styles/themes/*/index.scss', {eager: false, query: '?inline'});
type DynamicThemeImportType = { default: string };

let themeStyleElm: Element | null;

const switchThemeLocal = async (theme: string) => {
  // eslint-disable-next-line no-console
  console.log('switchTheme', theme);

  // Load the theme CSS
  const themeImport = await themes[`../styles/themes/${theme}/index.scss`]() as DynamicThemeImportType;

  // Create the theme <style>
  if (!themeStyleElm) {
    themeStyleElm = Object.assign(
      document.createElement('style'),
      {
        id: 'theme-styles',
      }
    );
    document.head.appendChild(themeStyleElm);
  }

  // Apply the loaded styles
  themeStyleElm.innerHTML = themeImport.default;
};

const linkId = 'ws-theme-stylesheet';
const switchThemeRemote = async (theme: string) => {
  const {data: manifest} = await Axios.get(
    config.assetUrl + '/manifest.json'
  );

  let linkElm = document.getElementById(linkId);
  if (!linkElm) {
    linkElm = Object.assign(
      document.createElement('link'),
      {
        id: linkId,
        rel: 'stylesheet',
        'data-type': 'theming-link',
      });

    document.body.appendChild(linkElm);
  }

  linkElm.setAttribute(
    'href',
    config.assetUrl + '/' + manifest[`src/styles/themes/${theme}/index.scss`]['file']
  );
};

export const switchTheme = async (theme: Theme) => {
  config.theme = theme;
  store.dispatch('theme/' + StoreActions.SET_THEME, {theme});
  setConfigValues(config);
  env.MODE === 'development' ? switchThemeLocal(theme) : await switchThemeRemote(theme);
};

if (env.MODE === 'development') {
  switchTheme(config.theme);
}

// @ts-ignore
window.switchTheme = switchTheme;


export const themeMixin = {
  computed: {
    themeCary(): boolean {
      // @ts-ignore
      return this.theme === Theme.CARY;
    },
    themeLoopia(): boolean {
      // @ts-ignore
      return this.theme === Theme.LOOPIA;
    },
    themeActive24(): boolean  {
      // @ts-ignore
      return this.theme === Theme.ACTIVE_24;
    },
    themeAdmin(): boolean {
      // @ts-ignore
      return this.theme === Theme.ADMIN || !config.theme; // fallback to admin
    },
  },
  methods: {
    isTheme(theme: Theme): boolean {
      // @ts-ignore
      return this.$store.getters['theme/currentTheme'] === theme;
    },
    currentTheme(): any  {
      // @ts-ignore
      return this.$store?.getters?.['theme/currentTheme'];
    }
  },
};
